// extracted by mini-css-extract-plugin
export default {"wrapper":"Card_wrapper__bEwCf","card":"Card_card__jWv98","info":"Card_info__YW44T"};